import { IAllPrivateRoutes } from "components/routes/app_routes";
import { admin, user } from "config/roles";
import { HomePage } from "domains/Home/screens";
import { Notification } from "domains/Notification/screen";
import UserAddress from "domains/UserAddress";
import { ProfilUser, Users } from "../screens";

export const UserRoutes: IAllPrivateRoutes[] = [
  { label: "Home", pathName: "/", routeElement: HomePage, roles: user.roles },

  {
    label: "Users",
    pathName: "/users",
    routeElement: Users,
    roles: admin.roles,
  },
  {
    label: "Profile",
    pathName: "/users/profile",
    routeElement: ProfilUser,
    roles: user.roles,
  },
  {
    label: "Notification",
    pathName: "/notification",
    routeElement: Notification,
    roles: user.roles,
  },
  {
    label: "Address",
    pathName: "/address",
    routeElement: UserAddress,
    roles: user.roles,
  },
];
